import { sxswLondonEntities, sxswLondonEntityById } from './sxswLondon';
import { sxswSydneyEntities, sxswSydneyEntityById } from './sxswSydney';

export const experienceEntities = [...sxswLondonEntities, ...sxswSydneyEntities];
export const experienceEntityById = { ...sxswLondonEntityById, ...sxswSydneyEntityById };
